import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '../Icon';
import logoSrc from './hylylogo.svg'

const header_styles = theme => ({
  root: {
    cursor: 'pointer',
    padding: `${theme.margins.sm}px`,
  },
  list_item: {
    fontSize: 20,
    color: "#333333",
    fontWeight: 600,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    lineHeight: 1.5,
    whiteSpace: 'nowrap'
  },
  zero_margin_right: {
    marginRight: 0,
    minWidth: 20
  },
  rotate_icon: {
    webkitTransform: "rotate(180deg)",
    transform: "rotate(180deg)",
    color: "#333333",
  },
  default_icon: {
    webkitTransform: "rotate(0deg)",
    transform: "rotate(0deg)",
    color: "#333333",
    "&:hover":{
       color: "#26bbed",
    }
  }
})

export default React.memo(withStyles(header_styles)(({
  classes,
  name,
  onClick,
  pressed,
  menu_open,
  currentTarget,
  swipeable
}) => {
  const matchesSwipeable = useMediaQuery("(min-width:1280px)");

  return (
    <>
      <ListItem classes={{ root: classes.root }} onClick={onClick}>
        <ListItemIcon>
          <img src={logoSrc} alt="logo" />
        </ListItemIcon>
        {
          !matchesSwipeable && !menu_open ? "" :
            <ListItemText
              primary={swipeable ? name : menu_open ? name : ""}
              classes={{
                primary: classes.list_item
              }}
            />
        }
        {
          swipeable || menu_open ? <ListItemIcon className={classes.zero_margin_right}>
            <Icon type="icon-triangle-down" size="xs" className={pressed ? classes.rotate_icon : classes.default_icon} />
          </ListItemIcon>
            :
            <ListItemIcon style={{ marginLeft: -15 }}>
              <Icon type="icon-right-arrow" size="sm" className={currentTarget ? classes.rotate_icon : classes.default_icon} />
            </ListItemIcon>
        }

      </ListItem>
    </>
  )
}
))
